<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    白石洲站<br>
站点介绍<br>
本站位于深南大道地下，车站主体平行于深南大道，呈东西走向，白石洲站在装修上充分体现未来的概念，在天花的处理上运用了椭圆造型强调“洲岛”的概念，室内设计注意简洁、明快、大方，避免繁琐装饰，用材尽量简洁、统一。在室内的顶棚、地面、墙面在色彩处理上取浅色调，且以色彩鲜艳、醒目的导向牌、广告灯箱作为点缀，使乘客在地铁站里感到轻松、方便。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:03	23:36	1号线	2分钟	4分40秒<br>
机场东	06:02	23:32	1号线	2分钟	4分40秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:27	23:35	1号线	3分45秒	5分45秒<br>
机场东	06:22	23:31	1号线	3分45秒	5分45秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:27	00:35	1号线	3分45秒	5分45秒<br>
机场东	06:22	00:31	1号线	3分45秒	5分45秒<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
深南大道北侧（东）、沙河街、下白石村、沙河小学<br><br>
B出入口:<br>
深南大道北侧（西）、沙河东路（北）<br><br>
C出入口:<br>
深南大道南侧（西）、南山中英文学校、深圳市不动产登记中心南山登记所、沙河东路（南）<br><br>
D出入口:<br>
深南大道南侧（东）、博耐建材家具广场、南山京基百纳广场、石洲中路<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 白石洲①<br>
21、90、101、204、223、M487、320、M222、M413、M448、144<br><br>
A出入口:<br>
公交站名： 白石洲②<br>
113、323、324、328、369、M312、M191、M194、395、70<br><br>
B出入口:<br>
公交站名： 白石洲③<br>
26、42、43、66、392、M132、M425、M535、M435<br><br>
C出入口:<br>
公交站名： 白石洲③<br>
26、42、43、66、392、M132、M312、M425、M486、M435、M535、235<br><br>
D出入口:<br>
公交站名： 白石洲①<br>
21、70、90、101、204、223、M487、N4<br><br>
D出入口:<br>
公交站名： 白石洲②<br>
113、320、323、324、328、369、M191、M194、M222、M413、M448、M486、395<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>






